(function () {
    'use strict';

    /**
     * Social links section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_SocialLinks.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "socialLinksSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionSocialLinks', sectionSocialLinks);

    function sectionSocialLinks() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionSocialLinksCtrl,
            controllerAs: 'socialLinksSection'
        };
    }

    SectionSocialLinksCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionSocialLinksCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.items = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the social network links of the event (not language dependent)
         * @param {number} eventId
         * @returns {Promise}
         */
        function load(eventId) {
            return ApiFactory.GetSocialLinks(eventId).then(function (response) {
                vm.items = response.data;
            });
        }
    }
})();
